<template>
    <div class="dashboard--btn sub" @click="$emit('click')">
        <div class="sub__info">
            <div class="dashboard--btn__title sub__title">
                <img :src="icon" alt="" />
                <div class="sub__label">{{ label }}</div>
            </div>
            <div class="sub__desc">{{ description }}</div>
        </div>
        <img class="sub__arrow" src="@/assets/images/dark/icon_left.png" alt="arrow" />
    </div>
</template>

<script>
export default ({
    name: 'SubButton',
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    },
    emits: ['click']
})
</script>

<style scoped>
.dashboard--btn.sub {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--Menu-Dark);
    padding: 0.75rem 1rem;
    border-radius: 8px;
    cursor: pointer;
}

.sub__info {
    display: flex;
    flex-direction: column;
}

.sub__title {
    display: flex;
    align-items: center;
}

.sub__title img {
    width: 20px;
    height: 20px;
    margin-right: 6px;
}

.sub__label {
    color: var(--Main);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
}

.sub__desc {
    padding-top: 1px;
    color: #72747B;
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
}

.sub__arrow {
    width: 20px;
    height: 20px;
}

@media (max-width: 400px) {
    .sub__label {
        font-size: 14px;
        font-weight: 400;
    }
}
</style>
